import { useLocale } from '@vuepress/helper/client';
/**
 * Git plugin locales
 *
 * Git 插件多语言配置
 */
export const locales = typeof __GIT_LOCALES__ === 'undefined' ? {} : __GIT_LOCALES__;
/**
 * Git locale composable
 *
 * Git 多语言组合式函数
 */
export const useGitLocale = () => useLocale(locales);
